<template>
    <div v-if="show && acordos && acordos.length">
        <h3>Possíveis acordos parlamentares</h3>
        <graficos-colunas :items="acordos" comparador linhas/>
    </div>
</template>

<script>
import { percentage, numbers, sort } from '@/core/utils'
import utils from '@/widgets/eleicoes/partidos'

export default {
    data: () => ({
        show: false
    }),
    computed: {
        acordos() {
            if(!this.$state.data || !this.$state.data.resultados || !this.$state.data.resultados.length) return;
            let data = [];
            let partidos = {};
            this.$state.data.resultados.forEach(item => (partidos[item.opcao] = {
                ...item,
                title: item.opcao,
                votos: numbers(item.votos || 0),
                mandatos: parseInt(item.mandatos || 0),
                color: utils.cor(item.opcao),
                slug: utils.partify(item.opcao)
            }));
            utils.acordos.forEach(item => {
                let info = [], res = {
                    items: [],
                    value: 0
                };
                item.forEach(partido => {
                    if(partidos[partido]) {
                        res.value += parseInt(partidos[partido].mandatos || 0);
                        res.items.push(partidos[partido]);
                        res.percent = percentage(res.value * 100 / 230);
                    }
                });
                res.items.forEach(item => {
                    info.push(item.title);
                    item.value = item.mandatos * 100 / 230;
                });
                res.items.reverse();
                res.info = info.join(' + ');
                res.items.length > 1 && data.push(res);
            });
            const items = !data || !data.length ? null : data.filter(item => item.value >= 115);
            return !items ? null : sort(items, 'percent', true);
        }
    }
}
</script>